<template>
  <SolutionPageLayout title="Corporations" section="Sectors">
    <p>
      Corporate programmes—from sales kick-offs to leadership summits—need a secure, on-brand experience for employees, customers, and partners.
    </p>
    <p>
      Entegy connects registration, event sites, mobile apps, and on-site logistics so internal teams can run professional events without relying on a patchwork of vendors.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
